{
  "version": 1,
  "asset_id": "d2eb45af-4b67-4249-b2e1-25d2e4a3c37f",
  "project_id": "ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe",
  "url": "/__l5e/assets-v1/d2eb45af-4b67-4249-b2e1-25d2e4a3c37f/monroya-logo.png",
  "r2_key": "a/v1/ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe/d2eb45af-4b67-4249-b2e1-25d2e4a3c37f/monroya-logo.png",
  "original_filename": "monroya-logo.png",
  "size": 9265,
  "content_type": "image/png",
  "created_at": "2026-06-25T17:01:37Z"
}
